import { formatDateValue } from "@common";

export const EMPTY_VALUE = "";

const formatArrayValue = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return EMPTY_VALUE;
  return (
    arr
      .map((item) => {
        if (item === null || item === undefined) return "";
        if (typeof item === "object") {
          return (
            item?.name ||
            item?.label ||
            item?.email ||
            item?.value ||
            JSON.stringify(item)
          );
        }
        return String(item).trim();
      })
      .filter(Boolean)
      .join(", ") || EMPTY_VALUE
  );
};

export const getValue = (value) => {
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;

  if (Array.isArray(value)) {
    return formatArrayValue(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return formatArrayValue(parsed);
        }
      } catch {
        // Fall back to returning string as is
      }
    }
  }

  return value;
};
const getCurrecyValue = (currencyValue, currencyCode) => {
  return currencyValue ? `${currencyCode || ""} ${currencyValue || ""}` : ""
}
export const getBasicInformationView = (data = {}) => ({
  left: [
    { label: "Planned Budget", value: getCurrecyValue(data?.plannedBudget, data?.customerCurrency?.currencyCode), },
    {
      label: "Planned Start",
      value: data?.startDate ? formatDateValue(data.startDate) : EMPTY_VALUE,
    },
    {
      label: "Planned End",
      value: data?.endDate ? formatDateValue(data.endDate) : EMPTY_VALUE,
    },
  ],
  right: [

    {
      label: "Actual Start",
      value: data?.actualStartDate
        ? formatDateValue(data.actualStartDate)
        : EMPTY_VALUE,
    },
    {
      label: "Actual End",
      value: data?.actualEndDate
        ? formatDateValue(data.actualEndDate)
        : EMPTY_VALUE,
    },


  ],
  fullWidth: [
    {
      label: "Campaign Objective",
      value: getValue(data?.campaignObjective),
    },
    { label: "Description", value: getValue(data?.description) },
    { label: "Notes", value: getValue(data?.notes) },
  ],
});

export const getCampaignTargetMetricView = (data = {}, basicData = {}) => ({
  left: [
    { label: "Expected Revenue", value: getCurrecyValue(data?.expectedRevenue, basicData?.customerCurrency?.currencyCode) },
    { label: "Expected Leads", value: getValue(data?.expectedLeads) },
    {
      label: "Expected Conversions",
      value: getValue(data?.expectedConversions),
    },
    { label: "Expected Responses", value: getValue(data?.expectedResponses) },
    {
      label: "Expected Opportunities",
      value: getValue(data?.expectedOpportunities),
    },
    { label: "Notes", value: getValue(data?.notes) },
  ],
  right: [

  ],
  fullWidth: [

  ],
});
